import { useEffect, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  onClose?: () => void;
  size?: 'sm' | 'md' | 'lg';
}

export function Modal({ children, onClose, size }: Props): JSX.Element {
  useEffect(() => {
    if (!onClose) return;
    const onEsc = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onEsc);
    return () => window.removeEventListener('keydown', onEsc);
  }, [onClose]);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className={`modal${size === 'md' ? ' md' : size === 'lg' ? ' lg' : ''}`} onClick={(e) => e.stopPropagation()}>
        {children}
      </div>
    </div>
  );
}
